import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Services from './pages/Services';
import TrackRecord from './pages/TrackRecord';
import Team from './pages/Team';
import Contact from './pages/Contact';
import SuppliersCircle from './pages/SuppliersCircle';
import GrainSpecifications from './pages/GrainSpecifications';
import CustomGrading from './pages/CustomGrading';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  React.useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <div className="flex-grow">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services" element={<Services />} />
            <Route path="/track-record" element={<TrackRecord />} />
            <Route path="/team" element={<Team />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/suppliers/become-a-supplier" element={<SuppliersCircle />} />
            <Route path="/services/grain-specifications" element={<GrainSpecifications />} />
            <Route path="/services/custom-grading" element={<CustomGrading />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
